/**
 * 我的任务
 * 2019-05-08
 * Qian.qianchen
 */
"use strict";
angular.module("myAssignmentsModule", [
    "myAssignmentsRouterModule", //我的任务总路由
    "myAllAssignmentsModule", //所有任务模块
    "executeAssignmentsModule", //执行任务模块
]);